import React, { useCallback } from 'react';

import { Formik } from 'formik';
import type { FormikProps } from 'formik';
import type { IAffiliateCommissionFilter } from 'v2/interfaces/reports/affiliateCommissions';
import { initialFilter, affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

import { Form } from './Form';

export const Filter = () => {
  const onSubmit = useCallback(
    (values: IAffiliateCommissionFilter, { setSubmitting }: FormikProps<IAffiliateCommissionFilter>) => {
      affiliateCommissionsService.setFilter(values);
      setSubmitting(false);
    },
    []
  );

  return (
    <Formik initialValues={initialFilter} onSubmit={onSubmit}>
      <Form />
    </Formik>
  );
};
